import {
  useWSModal,
  WSActions,
  WSAlert,
  WSElement,
  WSFlexBox,
  WSPanel
} from "@wingspanhq/fe-component-library";
import { IPayeeEngagementResponse } from "@wingspanhq/payments/dist/interfaces";
import { FieldView } from "../../../shared/components/FieldView/FieldView";
import React from "react";

export interface RestorationNotAllowedModalProps {
  payeeId: string;
  payeeName: string;
  engagement: IPayeeEngagementResponse;
  onClose: () => void;
}

export const RestorationNotAllowedModal: React.FC<
  RestorationNotAllowedModalProps
> = ({ payeeName, engagement, onClose }) => {
  return (
    <>
      <WSPanel>
        <WSFlexBox gap="XL">
          <FieldView
            label="Assignment name"
            value={engagement.engagementName}
          />
          <FieldView label="Contractor name" value={payeeName} />
        </WSFlexBox>
      </WSPanel>

      <WSAlert
        my="2XL"
        theme="warning"
        icon="alert"
        size="M"
        title="Assignment cannot be restored when:"
      >
        <WSElement as="ul" ml="L">
          <li>The engagement was archived</li>
        </WSElement>
        To restore assignments related to an engagement, restore the engagement
        first.
      </WSAlert>

      <WSActions
        alignment="fill"
        buttons={[
          {
            label: "Done",
            onClick: onClose,
            kind: "Secondary"
          }
        ]}
      />
    </>
  );
};

export const useRestorationNotAllowedModal = () => {
  return useWSModal(RestorationNotAllowedModal, {
    title: "Restore assignment",
    size: "M"
  });
};
